import { useLocation } from 'react-router-dom';

import { getMailboxViewFromPath } from '../helpers';

const useMailboxRoute = () => {
    const location = useLocation();

    return getMailboxViewFromPath(location.pathname);
};

export default useMailboxRoute;
